













































































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import ImplementasiInputMpp from "@/components/mpp/ImplementasiMppInput.vue";
import ListImplementasiMpp from "@/components/mpp/ListImplementasiMpp.vue";
import ImplementasiMppModal from "@/components/mpp/ImplementasiMppModal.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import mppModule from "@/store/modules/MppStore";
import { confirmRemove } from "@/utility/CommonHelper";

@Component({
  components: {
    ImplementasiInputMpp,
    ListImplementasiMpp,
    ImplementasiMppModal
  }
})
export default class ImplementasiMppPage extends Vue {
  @Ref("refInputImp") readonly refInputImp!: any;
  @Prop() readonly register!: number;
  @Prop() readonly rm!: string;
  @Prop({ type: Boolean, default: false }) isReadonly!: boolean;

  dialog = false;
  selectedItem: any = null;
  showFullscreen = false;
  saving = false;
  loading = false;
  category = "implementasi";

  get riwayat() {
    return mppModule.getImplementasi;
  }

  get stateUser() {
    return userModule.user;
  }

  async loadData() {
    await mppModule.fetchAllMpp(this.register);
  }

  OpenModal() {
    if (this.refInputImp) {
      this.refInputImp.resetForm();
    }

    this.selectedItem = {
      id: null,
      unit_id: this.stateUser?.unit_id || null,
      user_id: this.stateUser?.id || null,
      unit: { id: this.stateUser?.unit_id, nama: this.stateUser?.unit },
      user: { id: this.stateUser?.id, nama: this.stateUser?.nama },
      authored_at: new Date(), // Pastikan format Date object
      content: { implementasi: [], evaluasi: [], keterangan: "" }
    };

    this.dialog = true;
  }

  Close() {
    this.dialog = false;
    setTimeout(() => {
      this.selectedItem = null;
      if (this.refInputImp) this.refInputImp.resetForm();
    }, 200);
  }

  async Save() {
    if (this.saving) return;

    if (!this.refInputImp) return;

    if (this.refInputImp && !this.refInputImp.validasi()) {
      appModule.sendErrorAlert("Mohon lengkapi Tanggal & Jam Pencatatan.");
      return;
    }

    const imputImp = this.refInputImp;

    // Validasi form child
    if (!imputImp.isValidForm) {
      const message =
        "Mohon lengkapi data: \n" + imputImp.validationErrors.join("\n");
      appModule.sendErrorAlert(message);
      return;
    }

    this.saving = true;

    // Ambil payload dari getter komponen anak
    const payload = imputImp.sendData;

    try {
      await mppModule.saveMpp({
        category: this.category,
        data: payload,
        isEdit: !!this.selectedItem?.id
      });
      appModule.sendSuccessNotice("Data implementasi berhasil disimpan");
      this.Close();
      //await this.loadData(); // Reload list agar sinkron
    } catch (error) {
      console.error("Error saving implementasi:", error);
      // Error alert biasanya sudah ditangani di service interceptor
    } finally {
      this.saving = false;
    }
  }

  Edit(item: any) {
    this.selectedItem = JSON.parse(JSON.stringify(item));

    if (
      this.selectedItem.authored_at &&
      typeof this.selectedItem.authored_at === "string"
    ) {
      this.selectedItem.authored_at = new Date(this.selectedItem.authored_at);
    }

    this.dialog = true;
  }

  async Delete(item: any) {
    const confirmed = await confirmRemove(
      "Apakah Anda yakin ingin menghapus data implementasi ini?"
    );

    if (confirmed) {
      try {
        //await AskepMppSvc.destroy(item.id, "implementasi", "");
        await mppModule.deleteMpp({
          category: this.category,
          id: item.id
        });
        appModule.sendSuccessNotice("Data berhasil dihapus");
        //await this.loadData(); // Reload data
      } catch (error) {
        console.error("Gagal menghapus data:", error);
      }
    }
  }
}
